import { jsonApi } from '../jsonApi';

jsonApi.define('tms/rule-type', {
  id_category: null,
  id: null,
});
